import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import { TextField, SelectField, Loadable, If } from "components/support";

import _ from "lodash";

class CustomerFormGeographicInfo extends Component {
  static States = [
    "RO",
    "AC",
    "AM",
    "RR",
    "PA",
    "AP",
    "TO",
    "MA",
    "PI",
    "CE",
    "RN",
    "PB",
    "PE",
    "AL",
    "SE",
    "BA",
    "MG",
    "ES",
    "RJ",
    "SP",
    "PR",
    "SC",
    "RS",
    "MS",
    "MT",
    "GO",
    "DF"
  ];

  render() {
    const {
      viewModel,
      customer,
      fields,
      errors,
      onChange,
      presenter
    } = this.props;
    const { address } = customer;
    const { loading } = viewModel;

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <div className="grid-container mt-sm mb-sm">
                <Row>
                  <If
                    test={
                      _.findIndex(fields, { show: false, key: "zipcode" }) ===
                      -1
                    }
                  >
                    <Col xs={12} lg={3}>
                      <TextField
                        floatingLabelFixed={true}
                        floatingLabelText="CEP"
                        maskPattern={[
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          "-",
                          /\d/,
                          /\d/,
                          /\d/
                        ]}
                        maxLength={8}
                        type="tel"
                        value={address.zipcode}
                        errorText={errors["address.zipcode"]}
                        onChange={(_, value) =>
                          presenter.onZipcodeChange(value)
                        }
                        underlineShow={false}
                        fullWidth
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, { show: false, key: "state" }) === -1
                    }
                  >
                    <Col xs={6} lg={2}>
                      <SelectField
                        floatingLabelFixed={true}
                        floatingLabelText="Estado"
                        value={address.state}
                        errorText={errors["address.state"]}
                        onChange={(_, value) =>
                          onChange("address", "state", value)
                        }
                        underlineStyle={{ bottom: "0" }}
                        labelStyle={{ height: "44px" }}
                        fullWidth
                        options={CustomerFormGeographicInfo.States.map(
                          state => {
                            return {
                              value: state,
                              label: state
                            };
                          }
                        )}
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, { show: false, key: "city" }) === -1
                    }
                  >
                    <Col xs={6} lg={3}>
                      <TextField
                        floatingLabelFixed={true}
                        floatingLabelText="Cidade"
                        maxLength={34}
                        value={address.city}
                        errorText={errors["address.city"]}
                        onChange={(_, value) =>
                          onChange("address", "city", value)
                        }
                        underlineShow={false}
                        fullWidth
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, {
                        show: false,
                        key: "neighborhood"
                      }) === -1
                    }
                  >
                    <Col xs={12} lg={4}>
                      <TextField
                        floatingLabelFixed={true}
                        floatingLabelText="Bairro"
                        maxLength={34}
                        value={address.neighborhood}
                        errorText={errors["address.neighborhood"]}
                        onChange={(_, value) =>
                          onChange("address", "neighborhood", value)
                        }
                        underlineShow={false}
                        fullWidth
                        required
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, { show: false, key: "street" }) === -1
                    }
                  >
                    <Col xs={12} lg={8}>
                      <TextField
                        floatingLabelFixed={true}
                        floatingLabelText="Logradouro"
                        maxLength={34}
                        value={address.street}
                        errorText={errors["address.street"]}
                        onChange={(_, value) =>
                          onChange("address", "street", value)
                        }
                        underlineShow={false}
                        fullWidth
                        required
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, { show: false, key: "number" }) === -1
                    }
                  >
                    <Col xs={12} lg={4}>
                      <TextField
                        floatingLabelFixed={true}
                        floatingLabelText="Número"
                        maxLength={5}
                        type="tel"
                        value={address.number}
                        errorText={errors["address.number"]}
                        onChange={(_, value) =>
                          onChange("address", "number", value)
                        }
                        underlineShow={false}
                        fullWidth
                        required
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, {
                        show: false,
                        key: "complement"
                      }) === -1
                    }
                  >
                    <Col xs={12}>
                      <TextField
                        floatingLabelFixed={true}
                        floatingLabelText="Complemento"
                        maxLength={34}
                        value={address.complement}
                        errorText={errors["address.complement"]}
                        onChange={(_, value) =>
                          onChange("address", "complement", value)
                        }
                        underlineShow={false}
                        fullWidth
                      />
                    </Col>
                  </If>
                </Row>
              </div>
            </Loadable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CustomerFormGeographicInfo;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/geographic-info/view.jsx